import * as queryString from 'query-string';
import { utils } from '@blend/ui-common';

import * as stateUtils from './stateUtils';
import { getWindow } from './globalWrappers';

export const initializeTagManagersWithMarketingParams = () => {
  const window = getWindow();
  const query = queryString.parse(queryString.extract(window.location.href));
  // app_source is an interally defined marketing param, so include it
  const stateParams = stateUtils.getOptionalCreationParams(query, [...stateUtils.allMarketingParams, 'app_source']);
  const dataLayerParams = (stateParams.marketing || {}) as Record<string, string>;

  if (stateParams.app_source) {
    dataLayerParams['blend.appSource'] = stateParams.app_source as string;
  }

  utils.tagManagerUtils.setup(dataLayerParams);
};
